import { BrowserRouter } from "react-router-dom";
import Login from "./auth/login";
import MainLayout from "./layout/layout";
import { Layout, theme, ConfigProvider } from "antd";
import { useSelector } from "react-redux";
import CustomToast from "./lib/toaster";

function App() {
  const { id, select_theme } = useSelector((state) => state.user);

  return (
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#4D0000",
          },

          components: {
            Layout: {
              siderBg: select_theme === "white" ? "#ffffff" : "#000000",
              headerBg: select_theme === "white" ? "#f0f0f0" : "#121212",
              bodyBg: select_theme === "white" ? "#f0f0f0" : "#121212",
            },
            Menu: {
              itemBg: select_theme === "white" ? "#ffffff" : "#000000",
              itemSelectedBg: "#4D0000",
              itemSelectedColor: "#ffffff",
              subMenuItemSelectedColor:
                select_theme === "white" ? "#000000" : "#ffffff",
            },

            Table: {
              colorBgContainer:
                select_theme === "white" ? "#ffffff" : "#000000",
              headerBg: select_theme === "white" ? "#ffffff" : "#000000",
            },
          },

          algorithm:
            select_theme === "white"
              ? theme.compactAlgorithm
              : theme.darkAlgorithm,
        }}
      >
        {id ? (
          <MainLayout />
        ) : (
          <Layout style={{ height: "100vh" }}>
            <Login />
          </Layout>
        )}
        <CustomToast />
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
